<template>
    <modal size="large" :no-footer="true" @close="$emit('close')">
        <template slot="header">
            <strong>Create a new cycle</strong>
        </template>

        <template slot="content">
            <p>Use the form below to create a new cycle. The facility must already be set up at this point.</p>

            <form @submit.prevent="onSubmit">
                <div class="flex jc-sb">
                    <div class="flex-50 mr-2">
                        <label>
                            Facility Number:<br />
                            <input :disabled="isLoading" type="text" required v-model="inputs.facility_number" />
                        </label>
                    </div>

                    <div class="flex-50 ml-2">
                        <label>
                            Label:<br />
                            <input :disabled="isLoading" type="text" required v-model="inputs.label" />
                        </label>
                    </div>
                </div>

                <div class="flex jc-sb mt-4">
                    <div class="flex-33 mr-2">
                        <label>
                            Initial Letter Date:<br />
                            <datepicker :disabled="isLoading" :typeable="true" v-model="inputs.initial_letter_send_date" format="MM/dd/yyyy" />
                        </label>
                    </div>

                    <div class="flex-33 ml-2 mr-2">
                        <label>
                            Reminder Letter Date:<br />
                            <datepicker :disabled="isLoading" :typeable="true" v-model="inputs.reminder_letter_send_date" format="MM/dd/yyyy" />
                        </label>
                    </div>

                    <div class="flex-33 ml-2">
                        <label>
                            Letter Effective Date:<br />
                            <datepicker :disabled="isLoading" :typeable="true" v-model="inputs.letter_effective_date" format="MM/dd/yyyy" />
                        </label>
                    </div>
                </div>

                <div class="flex jc-sb mt-4">
                    <div class="flex-50 mr-2">
                        <label>
                            Update Responses Deadline Date:<br />
                            <datepicker :disabled="isLoading" :typeable="true" v-model="inputs.update_responses_deadline_date" format="MM/dd/yyyy" />
                        </label>
                    </div>

                    <div class="flex-50 ml-2">
                        <label>
                            Tag for Removal Deadline Date:<br />
                            <datepicker :disabled="isLoading" :typeable="true" v-model="inputs.tag_for_removal_deadline_date" format="MM/dd/yyyy" />
                        </label>
                    </div>
                </div>

                <div class="flex jc-sb mt-4">
                    <div class="flex-50 mr-2">
                        <label>
                            Setup Coverage Dates:<br />
                            <div class="flex ai-c jc-sb">
                                <datepicker :disabled="isLoading" :typeable="true" v-model="inputs.setup_coverage_start_date" format="MM/dd/yyyy" />

                                <span class="ml-2 mr-2">&ndash;</span>

                                <datepicker :disabled="isLoading" :typeable="true" v-model="inputs.setup_coverage_end_date" format="MM/dd/yyyy" />
                            </div>
                        </label>
                    </div>

                    <div class="flex-50 ml-2">
                        <label>
                            Monitor for Payment Dates:<br />
                            <div class="flex ai-c jc-sb">
                                <datepicker :disabled="isLoading" :typeable="true" v-model="inputs.monitor_payment_start_date" format="MM/dd/yyyy" />

                                <span class="ml-2 mr-2">&ndash;</span>

                                <datepicker :disabled="isLoading" :typeable="true" v-model="inputs.monitor_payment_end_date" format="MM/dd/yyyy" />
                            </div>
                        </label>
                    </div>
                </div>

                <div class="flex jc-sb mt-5">
                    <div class="flex-a mr-2">
                        <span class="danger-text">{{ errorMessage }}</span>
                    </div>

                    <div class="flex-0 flex jc-fe ml-2">
                        <div v-show="isLoading" class="flex ai-c mr-2">
                            <img src="@/assets/img/loading-black-32.gif" alt="loading" style="max-width: none;" />
                        </div>

                        <button :disabled="isLoading" type="submit">Save</button>
                    </div>
                </div>
            </form>
        </template>
    </modal>
</template>

<script>
import http from "@/http"
import { objectToParams } from "@/utilities/form-data"

export default {
    name: "new-cycle-modal",

    props: {
        onSuccess: {
            type: Function
        }
    },

    data () {
        return {
            errorMessage: "",
            inputs: {
                facility_number: "",
                letter_effective_date: new Date(),
                initial_letter_send_date: new Date(),
                reminder_letter_send_date: new Date(),
                update_responses_deadline_date: new Date(),
                tag_for_removal_deadline_date: new Date(),
                setup_coverage_start_date: new Date(),
                setup_coverage_end_date: new Date(),
                monitor_payment_start_date: new Date(),
                monitor_payment_end_date: new Date(),
                label: ""
            },
            isLoading: false
        }
    },

    methods: {
        /**
         * Make the API call to create the cycle.
         *
         * @return null
         */
        async onSubmit () {
            const params = objectToParams(this.inputs)

            this.isLoading = true

            try {
                const { data } = await http.post("/api/cycles", params)

                if (this.onSuccess) {
                    this.onSuccess(data.cycle_id)
                }

                this.$emit("close")
            } catch (ex) {
                this.errorMessage = ex
            } finally {
                this.isLoading = false
            }
        }
    }
}
</script>

<style scoped>
>>> .modal-body {
    overflow: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/manage-cycles-page/NewCycleModal.vue